module.exports = __webpack_public_path__ + "img/msg-right-offset.6237b41c.svg";